import { Routine } from "./../model/Routine.js";

export class RoutinenManager
{
    constructor()
    {
        this.categories = [
            {
                id: Routine.CATEGORY_DAILY_MORNING,
                name : 'Morgenroutine',
                weeklyFrequence : 7
            },
            {
                id : Routine.CATEGORY_DAILY_MIDDAY,
                name : 'Mittagsroutine',
                weeklyFrequence : 7
            },
            {
                id : Routine.CATEGORY_DAILY_EVENING,
                name : 'Abendroutine',
                weeklyFrequence : 7
            },
            {
                id : Routine.CATEGORY_DAILY_GOAL,
                name : 'Tagesziele',
                weeklyFrequence : 7
            },
            {
                id : Routine.CATEGORY_WEEKLY_GOAL_SPORT,
                name : 'Sport',
                weeklyFrequence : null
            },
            {
                id : Routine.CATEGORY_WEEKLY_GOAL_CONSUME,
                name : 'Konsum',
                weeklyFrequence : null
            },
            {
                id : Routine.CATEGORY_WEEKLY_GOAL_SPIRIT,
                name : 'Geistige Gesundheit',
                weeklyFrequence : null
            }
        ];

        this.routines = [
            { id: 1, goal : Routine.GOAL_DAILY, categoryId: Routine.CATEGORY_DAILY_MORNING, name : "Aufstehen", icon: "sun.svg" },
            { id: 2, goal : Routine.GOAL_DAILY, categoryId: Routine.CATEGORY_DAILY_MORNING, name : "Beim ersten Wecker klingeln aufstehen", icon: "time-alarm.svg" },
            { id: 3, goal : Routine.GOAL_DAILY, categoryId: Routine.CATEGORY_DAILY_MORNING, name : "Digitale Auszeit", icon: "lock-portrait.svg" },
            { id: 4, goal : Routine.GOAL_DAILY, categoryId: Routine.CATEGORY_DAILY_MORNING, name : "Dankbarkeitsjournal", icon: "book-open-2.svg" },
            { id: 5, goal : Routine.GOAL_DAILY, categoryId: Routine.CATEGORY_DAILY_MORNING, name : "Glaubenssätze", icon: "book.svg" },
            { id: 6, goal : Routine.GOAL_DAILY, categoryId: Routine.CATEGORY_DAILY_MORNING, name : "Glas Wasser trinken", icon: "detox.svg" },
            { id: 7, goal : Routine.GOAL_DAILY, categoryId: Routine.CATEGORY_DAILY_MORNING, name : "Hygienecheck", icon: "bathtub.svg" },
            { id: 8, goal : Routine.GOAL_DAILY, categoryId: Routine.CATEGORY_DAILY_MORNING, name : "Gesundes Frühstück", icon: "apple-2.svg" },
            { id: 9, goal : Routine.GOAL_DAILY, categoryId: Routine.CATEGORY_DAILY_MORNING, name : "Supplements nehmen", icon: "medicine.svg" },
            { id: 10, goal : Routine.GOAL_DAILY, categoryId: Routine.CATEGORY_DAILY_MORNING, name : "Tagesplanung", icon: "calendar-date.svg" },
            { id: 11, goal : Routine.GOAL_DAILY, categoryId: Routine.CATEGORY_DAILY_MIDDAY, name : "Aktiv eine Pause nehmen", icon: "coffee.svg" },
            { id: 12, goal : Routine.GOAL_DAILY, categoryId: Routine.CATEGORY_DAILY_MIDDAY, name : "Frische Luft schnappen", icon: "land-1.svg" },
            { id: 13, goal : Routine.GOAL_DAILY, categoryId: Routine.CATEGORY_DAILY_MIDDAY, name : "Etwas gesundes essen", icon: "apple-2.svg" },
            { id: 14, goal : Routine.GOAL_DAILY, categoryId: Routine.CATEGORY_DAILY_MIDDAY, name : "In Ruhe essen", icon: "diet-plan.svg" },
            { id: 15, goal : Routine.GOAL_DAILY, categoryId: Routine.CATEGORY_DAILY_MIDDAY, name : "Glas Wasser trinken", icon: "detox.svg" },
            { id: 16, goal : Routine.GOAL_DAILY, categoryId: Routine.CATEGORY_DAILY_EVENING, name : "Gesundes Abendbrot", icon: "apple-2.svg" },
            { id: 17, goal : Routine.GOAL_DAILY, categoryId: Routine.CATEGORY_DAILY_EVENING, name : "Hygienecheck", icon: "bathtub.svg" },
            { id: 18, goal : Routine.GOAL_DAILY, categoryId: Routine.CATEGORY_DAILY_EVENING, name : "Glas Wasser trinken", icon: "detox.svg" },
            { id: 19, goal : Routine.GOAL_DAILY, categoryId: Routine.CATEGORY_DAILY_EVENING, name : "Rückblick auf den Tag", icon: "sun-fog-29.svg"},
            { id: 20, goal : Routine.GOAL_DAILY, categoryId: Routine.CATEGORY_DAILY_EVENING, name : "Digitale Auszeit", icon: "lock-portrait.svg" },
            { id: 21, goal : Routine.GOAL_DAILY, categoryId: Routine.CATEGORY_DAILY_EVENING, name : "Schlafen gehen", icon: "single-bed.svg" },
            { id: 22, goal : Routine.GOAL_DAILY, categoryId: Routine.CATEGORY_DAILY_GOAL, name : "__WT__ Wasser am Tag", icon: "detox.svg", customValues : [ "2 Liter", "2-3 Liter", "3-4 Liter", "4+ Liter" ], question : "Wie viele Liter Wasser möchtest du täglich mindestens trinken?" },
            { id: 23, goal : Routine.GOAL_DAILY, categoryId: Routine.CATEGORY_DAILY_GOAL, name : "__WT__ am Tag", icon: "run-shoes.svg", customValues : [ "5.000 Schritte", "7.500 Schritte ", "10.000 Schritte", "12.500 Schritte", "15.000+ Schritte" ], question : "Wie viele Schritte möchtest du am Tag mindestens gehen?" },
            { id: 24, goal : Routine.GOAL_WEEKLY, categoryId: Routine.CATEGORY_WEEKLY_GOAL_SPORT, name : "__WT__ mal Sport", icon: "dumbbell.svg" },
            { id: 25, goal : Routine.GOAL_WEEKLY, categoryId: Routine.CATEGORY_WEEKLY_GOAL_SPORT, name : "__WT__ mal laufen gehen", icon: "athletics.svg" },
            { id: 26, goal : Routine.GOAL_WEEKLY, categoryId: Routine.CATEGORY_WEEKLY_GOAL_SPORT, name : "__WT__ mal ins Gym", icon: "pectoral-machine.svg" },
            { id: 27, goal : Routine.GOAL_WEEKLY, categoryId: Routine.CATEGORY_WEEKLY_GOAL_SPORT, name : "__WT__ mal Home Workouts", icon: "crunches.svg" },
            { id: 28, goal : Routine.GOAL_WEEKLY, categoryId: Routine.CATEGORY_WEEKLY_GOAL_SPORT, name : "__WT__ mal Yoga", icon: "yoga-1.svg" },
            { id: 29, goal : Routine.GOAL_WEEKLY, categoryId: Routine.CATEGORY_WEEKLY_GOAL_SPORT, name : "__WT__ mal Dehnen", icon: "stretching.svg" },
            { id: 30, goal : Routine.GOAL_WEEKLY, categoryId: Routine.CATEGORY_WEEKLY_GOAL_SPORT, name : "__WT__ mal Fahrrad fahren", icon: "cycling-track.svg" },
            { id: 31, goal : Routine.GOAL_WEEKLY, categoryId: Routine.CATEGORY_WEEKLY_GOAL_SPORT, name : "__WT__ mal Aquafitness", icon: "water-aerobics.svg" },
            { id: 32, goal : Routine.GOAL_WEEKLY, categoryId: Routine.CATEGORY_WEEKLY_GOAL_CONSUME, name : "__WT__ mal Zucker", icon: "chocolate.svg" },
            { id: 33, goal : Routine.GOAL_WEEKLY, categoryId: Routine.CATEGORY_WEEKLY_GOAL_CONSUME, name : "__WT__ mal Fleisch", icon: "chicken.svg" },
            { id: 34, goal : Routine.GOAL_WEEKLY, categoryId: Routine.CATEGORY_WEEKLY_GOAL_CONSUME, name : "__WT__ mal tierische Produkte", icon: "yogurt.svg" },
            { id: 35, goal : Routine.GOAL_WEEKLY, categoryId: Routine.CATEGORY_WEEKLY_GOAL_CONSUME, name : "__WT__ mal Obst", icon: "strawberry.svg" },
            { id: 36, goal : Routine.GOAL_WEEKLY, categoryId: Routine.CATEGORY_WEEKLY_GOAL_CONSUME, name : "__WT__ mal Gemüse", icon: "broccoli.svg" },
            { id: 37, goal : Routine.GOAL_WEEKLY, categoryId: Routine.CATEGORY_WEEKLY_GOAL_CONSUME, name : "__WT__ mal Fastfood", icon: "chips.svg" },
            { id: 38, goal : Routine.GOAL_WEEKLY, categoryId: Routine.CATEGORY_WEEKLY_GOAL_CONSUME, name : "__WT__ mal rauchen", icon: "smoking.svg" },
            { id: 39, goal : Routine.GOAL_WEEKLY, categoryId: Routine.CATEGORY_WEEKLY_GOAL_CONSUME, name : "__WT__ mal Alkohol", icon: "beer-95.svg" },
            { id: 40, goal : Routine.GOAL_WEEKLY, categoryId: Routine.CATEGORY_WEEKLY_GOAL_SPIRIT, name : "__WT__ mal meditieren", icon: "lotus-flower.svg" },
            { id: 41, goal : Routine.GOAL_WEEKLY, categoryId: Routine.CATEGORY_WEEKLY_GOAL_SPIRIT, name : "__WT__ mal spazieren gehen", icon: "land-1.svg" },
            { id: 42, goal : Routine.GOAL_WEEKLY, categoryId: Routine.CATEGORY_WEEKLY_GOAL_SPIRIT, name : "__WT__ mal Glaubenssätze", icon: "book-open-2.svg" },
            { id: 43, goal : Routine.GOAL_WEEKLY, categoryId: Routine.CATEGORY_WEEKLY_GOAL_SPIRIT, name : "__WT__ mal Dankbarkeit", icon: "hand-heart.svg" },
            { id: 44, goal : Routine.GOAL_WEEKLY, categoryId: Routine.CATEGORY_WEEKLY_GOAL_SPIRIT, name : "__WT__ mal lesen", icon: "book.svg" },
            { id: 45, goal : Routine.GOAL_WEEKLY, categoryId: Routine.CATEGORY_WEEKLY_GOAL_SPIRIT, name : "__WT__ mal Affirmationen anhören", icon: "music.svg" },
            { id: 46, goal : Routine.GOAL_WEEKLY, categoryId: Routine.CATEGORY_WEEKLY_GOAL_SPIRIT, name : "__WT__ mal malen", icon: "pen-01.svg" }
        ];
    }

    getRoutineOptionsByRoutineId( routineId )
    {
        let options = null;
        const routine = this.getRoutineById( routineId );
        if ( routine )
        {
            options = routine.getOptions();
        }

        return options;
    }

    getRoutinesForRegistration( categoryId )
    {
        let routines = [],
            routineIds = [];

        switch ( categoryId )
        {
            case Routine.CATEGORY_DAILY_MORNING:
                routineIds = [ 1, 2, 4, 6, 7, 10 ];
            break;

            case Routine.CATEGORY_DAILY_MIDDAY:
                routineIds = [ 11, 12, 13, 14, 15 ];
            break;

            case Routine.CATEGORY_DAILY_EVENING:
                routineIds = [ 16, 17, 19, 20, 21 ];
            break;

            case Routine.CATEGORY_DAILY_GOAL:
                routineIds = [ 22, 23 ];
            break;

            case Routine.CATEGORY_WEEKLY_GOAL_SPORT:
                routineIds = [24, 25, 26, 27, 28, 30];
                break;
            case Routine.CATEGORY_WEEKLY_GOAL_CONSUME:
                routineIds = [ 33, 34, 32, 36, 35, 38 ];
                break;
            case Routine.CATEGORY_WEEKLY_GOAL_SPIRIT:
                routineIds = [ 40, 41, 42, 44, 45, 46 ];
            break;
        }

        for ( let ri = 0; ri < routineIds.length; ri++ )
        {
            let r = this.getRoutineById( routineIds[ ri ] );
            if ( r )
            {
                routines.push( r );
            }
        }

        return routines;
    }

    getRoutinesByCategoryId( categoryId )
    {
        let routines = [],
            cd;
        for ( let ri = 0; ri < this.routines.length; ri++ )
        {
            if ( categoryId == this.routines[ ri ].categoryId )
            {
                cd = this.getCategoryDataById( this.routines[ ri ].categoryId );
                this.routines[ ri ].weeklyFrequence = cd.hasOwnProperty( 'weeklyFrequence' ) && null !== cd.weeklyFrequence ? +cd.weeklyFrequence : 7;
                routines.push( new Routine( this.routines[ ri ] ) );
            }
        }
        return routines;
    }

    getRoutineById( routineId )
    {
        let r = null,
            cd = null;
        for ( let ri = 0; ri < this.routines.length; ri++ )
        {
            if ( routineId == this.routines[ ri ].id )
            {
                cd = this.getCategoryDataById( this.routines[ ri ].categoryId );
                this.routines[ ri ].weeklyFrequence = cd.hasOwnProperty( 'weeklyFrequence' ) && null !== cd.weeklyFrequence ? +cd.weeklyFrequence : 7;
                r = new Routine( this.routines[ ri ] );
                break;
            }
        }
        return r;
    }

    getCategoryDataById( categoryId )
    {
        let cd = null;
        for ( let ci = 0; ci < this.categories.length; ci++ )
        {
            if ( categoryId === this.categories[ ci ].id )
            {
                cd = this.categories[ ci ];
                break;
            }
        }
        return cd;
    }

    isRoutineStatic( routineId )
    {
        const r = this.getRoutineById( routineId );
        if ( r )
        {
            return r.isStatic();
        }
        else
        {
            // Individual routines are always static
            return true;
        }
    }

    hasCustomValues( routineId )
    {
        const r = this.getRoutineById( routineId );
        return ( r && r.hasOwnProperty( ' customValues' ) ) ? true : false;
    }

    isWeeklyGoal( routineId )
    {
        const r = this.getRoutineById( routineId );
        return ( r && r.hasOwnProperty( ' goal' ) && r.goal === Routine.GOAL_WEEKLY ) ? true : false;
    }
}
